const PLAYOFF_PATTERN = /play-?off|winner/i

const FLAG_ENTRIES = [
  ['dz', 'Algeria', 'Algeriet'],
  ['ar', 'Argentina'],
  ['au', 'Australia', 'Australien'],
  ['at', 'Austria', 'Østrig', 'Ostrig'],
  ['ba', 'Bosnia and Herzegovina', 'Bosnien-Hercegovina', 'Bosnien Hercegovina'],
  ['be', 'Belgium', 'Belgien'],
  ['br', 'Brazil', 'Brasilien'],
  ['ca', 'Canada'],
  ['cv', 'Cabo Verde', 'Kap Verde'],
  ['co', 'Colombia'],
  ['hr', 'Croatia', 'Kroatien'],
  ['cd', 'DR Congo', 'Congo DR', 'Democratic Republic of the Congo', 'Den Demokratiske Republik Congo', 'DRC'],
  ['ci', 'Côte d\'Ivoire', 'Cote d\'Ivoire', 'Ivory Coast', 'Elfenbenskysten'],
  ['cw', 'Curaçao', 'Curacao'],
  ['cz', 'Czech Republic', 'Czechia', 'Tjekkiet'],
  ['ec', 'Ecuador'],
  ['eg', 'Egypt', 'Egypten'],
  ['gb-eng', 'England'],
  ['fr', 'France', 'Frankrig'],
  ['de', 'Germany', 'Tyskland'],
  ['gh', 'Ghana'],
  ['ht', 'Haiti'],
  ['ir', 'IR Iran', 'Iran'],
  ['iq', 'Iraq', 'Irak'],
  ['jp', 'Japan'],
  ['jo', 'Jordan'],
  ['kr', 'Korea Republic', 'Republic of Korea', 'South Korea', 'Sydkorea'],
  ['mx', 'Mexico'],
  ['ma', 'Morocco', 'Marokko'],
  ['nl', 'Netherlands', 'Holland'],
  ['nz', 'New Zealand', 'New Zealand'],
  ['no', 'Norway', 'Norge'],
  ['pa', 'Panama'],
  ['py', 'Paraguay'],
  ['pt', 'Portugal'],
  ['qa', 'Qatar'],
  ['sa', 'Saudi Arabia', 'Saudi-Arabien', 'Saudi Arabien'],
  ['gb-sct', 'Scotland', 'Skotland'],
  ['sn', 'Senegal'],
  ['za', 'South Africa', 'Sydafrika'],
  ['es', 'Spain', 'Spanien'],
  ['se', 'Sweden', 'Sverige'],
  ['ch', 'Switzerland', 'Schweiz'],
  ['tn', 'Tunisia', 'Tunesien'],
  ['tr', 'Turkey', 'Türkiye', 'Tyrkiet'],
  ['us', 'USA', 'United States'],
  ['uy', 'Uruguay'],
  ['uz', 'Uzbekistan', 'Usbekistan'],
]

const PLAYOFF_SUGGESTIONS = [
  'Winner Play-off A',
  'Winner Play-off B',
  'Winner Play-off C',
  'Winner Play-off D',
  'Winner Play-off 1',
  'Winner Play-off 2',
]

export const WORLD_CUP_TEAM_SUGGESTIONS = [
  ...FLAG_ENTRIES.map(([, canonical]) => canonical),
  ...PLAYOFF_SUGGESTIONS,
].sort((a, b) => a.localeCompare(b, 'da-DK'))

const normalizeKey = (name) => String(name || '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')

const LOOKUP = FLAG_ENTRIES.reduce((acc, [code, ...names]) => {
  names.forEach((name) => {
    acc[normalizeKey(name)] = code
  })
  return acc
}, {})

export function isPlayoffTeam(name) {
  return PLAYOFF_PATTERN.test(String(name || ''))
}

export function suggestFlagCode(name) {
  if (isPlayoffTeam(name)) return null
  return LOOKUP[normalizeKey(name)] || null
}

export function resolveFlagCode(name, storedCode) {
  const explicit = String(storedCode || '').trim().toLowerCase()
  if (explicit) return explicit
  return suggestFlagCode(name)
}

export function getTeamFlagUrl(name, storedCode) {
  if (isPlayoffTeam(name)) return null
  const code = resolveFlagCode(name, storedCode)
  if (!code) return null
  return `https://flagcdn.com/w40/${code}.png`
}

export function formatTeamDisplayName(name) {
  return String(name || '').toUpperCase()
}

export const GROUP_STAGE_NAMES = [
  'Group A', 'Group B', 'Group C', 'Group D',
  'Group E', 'Group F', 'Group G', 'Group H',
  'Group I', 'Group J', 'Group K', 'Group L',
]

export function groupStageLabel(groupName) {
  const letter = String(groupName || '').replace(/^Group\s+/i, '').trim()
  if (letter && /^Group\s+/i.test(String(groupName || ''))) {
    return `Gruppe ${letter.toUpperCase()}`
  }
  return String(groupName || '').replace(/\bGroup\b/gi, 'Gruppe')
}

/** Viser backend stage-navn (fx "Group A") på dansk i UI. */
export function worldCupStageLabel(stage) {
  return groupStageLabel(stage)
}
